const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_ID_RE = /\/\d+(?=\/|$)/g;

export const normalizePath = (path?: string): string => {
  if (!path) return "unknown";

  const queryStripped = path.split("?")[0];

  return queryStripped.replace(UUID_RE, ":id").replace(NUMERIC_ID_RE, "/:id");
};
